import * as React from 'react';
import classNames from 'classnames';
import { Tabs } from '../Tabs/Tabs';
import './GenericSummary.css';

interface Props {
  currentTabIndex: number;
  onTabClick: (event, index: number) => void;
  tabs: React.ReactNode[];
  customClass?: string;
  children?: React.ReactNode;
}

export const GenericSummary: React.FC<Props> = ({ currentTabIndex, onTabClick, tabs, customClass, children }) => {
  const rootClassName = classNames('GenericSummary', customClass);

  return (
    <div className={rootClassName}>
      <div className="GenericSummary__tabs">
        <Tabs currentTabIndex={currentTabIndex} onTabClick={onTabClick} tabs={tabs} customClass={customClass} />
      </div>
      <div className="GenericSummary__content">{children}</div>
    </div>
  );
};

GenericSummary.displayName = 'GenericSummary';

